/* eslint-disable new-cap */
import { FC, useEffect, useState } from 'react'
import styled from 'styled-components'
import { CardDS } from './../../'
import { tokens } from '@JOTAJornalismo/jota-design-system'

const { colors, fonts } = tokens

export const MOBILE_SIZE = '500px'
export const TABLET_SIZE = '1199px'

const ServicesComponent: FC = () => {
    const [windowWidth, setWindowWidth] = useState<any>()

    const handleResize = () => {
        setWindowWidth(window.innerWidth)
    }

    useEffect(() => {
        handleResize()
        window.addEventListener('resize', () => handleResize())
    }, [])
    return (
        <ServicesContainer>
            <Title>Descomplique os seus tributos</Title>
            <Subtitle>
                Unindo jornalismo especializado com ciência de dados, o JOTA PRO
                Tributos te permite:
            </Subtitle>
            <CardContainer>
                <CardDS
                    title='Monitorar o Carf'
                    titleSearchTerm=''
                    newsLink=''
                    image={
                        windowWidth > 500
                            ? `${process.env.NEXT_PUBLIC_SITE_BASE}/images/lp/tributos/service1.webp`
                            : `${process.env.NEXT_PUBLIC_SITE_BASE}/images/lp/tributos/service1-mobile.webp`
                    }
                    titleDisableHover
                    isVertical={windowWidth > 500}
                    size={windowWidth > 1200 ? 'medium' : 'small'}
                    text='Acesso às decisões das diferentes turmas do CARF'
                    imageDisableHover
                    imageAlt='monitorar-carf'
                />
                <CardDS
                    title='Antecipar a jurisprudência'
                    titleSearchTerm=''
                    newsLink=''
                    image={
                        windowWidth > 500
                            ? `${process.env.NEXT_PUBLIC_SITE_BASE}/images/lp/tributos/service2.webp`
                            : `${process.env.NEXT_PUBLIC_SITE_BASE}/images/lp/tributos/service2-mobile.webp`
                    }
                    titleDisableHover
                    isVertical={windowWidth > 500}
                    size={windowWidth > 1200 ? 'medium' : 'small'}
                    text='Receba as decisões do STF e STJ no mesmo dia do julgamento'
                    imageDisableHover
                    imageAlt='antecipar-jurisprudência'
                />
                <CardDS
                    title='Prever projetos de lei'
                    titleSearchTerm=''
                    newsLink=''
                    image={
                        windowWidth > 500
                            ? `${process.env.NEXT_PUBLIC_SITE_BASE}/images/lp/tributos/service3.webp`
                            : `${process.env.NEXT_PUBLIC_SITE_BASE}/images/lp/tributos/service3-mobile.webp`
                    }
                    titleDisableHover
                    isVertical={windowWidth > 500}
                    size={windowWidth > 1200 ? 'medium' : 'small'}
                    text='Acompanhe os bastidores de projetos de lei, a visão das lideranças e do relator'
                    imageDisableHover
                />
            </CardContainer>
        </ServicesContainer>
    )
}

export default ServicesComponent

const ServicesContainer = styled.div`
    display: grid;
    justify-content: space-between;
    padding: 72px 11%;

    @media only screen and (max-width: ${TABLET_SIZE}) {
        padding: 44px 36px;
        justify-content: center;
        justify-items: center;
    }

    @media only screen and (max-width: ${MOBILE_SIZE}) {
        padding: 44px 16px;
    }
`
export const Title = styled.h2`
    ${fonts.jotaHeading02};
    color: ${colors.black.jotaBlack};
    margin: 0;
    padding-bottom: 16px;

    @media only screen and (max-width: ${TABLET_SIZE}) {
        ${fonts.jotaHeading03};
        text-align: center;
    }

    @media only screen and (max-width: ${MOBILE_SIZE}) {
        padding-bottom: 24px;
    }
`
const Subtitle = styled.p`
    ${fonts.jotaBodyLarge};
    color: ${colors.gray.jotaGrayDark};
    margin: 0;
    padding: 0 0 36px 0;
    max-width: 778px;

    @media only screen and (max-width: ${TABLET_SIZE}) {
        text-align: center;
    }

    @media only screen and (max-width: ${MOBILE_SIZE}) {
        ${fonts.jotaBodyLarge};
        padding: 0 0 44px 0;
    }
`
const CardContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    justify-content: space-between;
    width: 100%;
    gap: 6%;

    @media only screen and (max-width: ${MOBILE_SIZE}) {
        flex-direction: column;
        align-items: center;
        grid-template-columns: none;
        gap: 44px;
        justify-content: center;
    }
`
